import { rem } from 'polished';
import styled from 'styled-components';

export const Container = styled.div`
    position: relative;
`;

export const FormWrapper = styled.div`
    display: grid;
    gap: ${rem(24)};
    padding: 0 ${rem(20)};
    max-width: ${rem(1440)};
    margin: 0 auto;
`;
